import { TContentType } from '@/types/Content.types';
import { HStack, Text } from '@chakra-ui/react';
import { getContentTypeLabel, TYPE_ICON } from './contentLabels';

// White icon + label, for overlaying on the dark/gradient thumbnail cards.
const ContentTypeTag = ({ type }: { type: TContentType }) => {
  const Icon = TYPE_ICON[type];
  return (
    <HStack display="inline-flex" gap="6px" align="center">
      <Icon size={14} strokeWidth={2.2} color="white" />
      <Text fontSize="11px" fontWeight={700} color="white" textTransform="uppercase" letterSpacing="0.5px">
        {getContentTypeLabel(type)}
      </Text>
    </HStack>
  );
};

export default ContentTypeTag;
